{
  "fr": {
    "backofficeHeader": {
      "exit": "Quitter le Backoffice"
    }
  }
}
